import { Trans } from '@lingui/macro';
import { Menu, MenuBody, MenuList, MenuItem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useApi } from 'app/domains/api-management';
export function KeyDialogMenu(props) {
    const { onClose, id, open, children } = props;
    const { setDialog } = useApi();
    const handleOpen = (dialog) => {
        onClose();
        setDialog({ id, type: dialog });
    };
    return (<Menu open={open} onClose={onClose} target={children}>
      <MenuBody>
        <MenuList>
          <MenuItem onClick={() => handleOpen('edit')}>
            <Falcon icon="pen"/>
            <Trans comment="Key Dialog - Edit">Edit</Trans>
          </MenuItem>
          <MenuItem onClick={() => handleOpen('delete')}>
            <Falcon icon="trash"/>
            <Trans comment="Key Dialog - Delete">Delete</Trans>
          </MenuItem>
        </MenuList>
      </MenuBody>
    </Menu>);
}
